import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import styled from 'styled-components';

import { COLORS } from '../../../theme';

export const FilterListContainer = styled(Box)`
  display: flex;
  align-items: start;
  gap: ${({ theme }) => theme.spacing.s4};
`;

export const FilterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.s2};
`;

export const Label = styled.span`
  display: flex;
  align-items: center;
  color: ${COLORS.black50};
  font-size: ${({ theme }) => theme.fontSize.body3};
  margin-right: ${({ theme }) => theme.spacing.s2};
`;

export const ResetButton = styled(Button)`
  &&& {
    min-width: 70px;
    height: 28px;
    min-height: unset;
    margin-left: auto;
    font-size: ${({ theme }) => theme.fontSize.body2};
  }
`;

export const QueryFilterElement = styled.span`
  display: flex;
`;
